import React from 'react';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

import { useAccount } from 'catering/context/providers/AccountProvider';
import { useGoogleApi } from 'catering/context/providers/GoogleApiProvider';
import DarkCover from 'components/DarkCover';
import Hero from 'components/Hero';
import FulfillmentMethodAvailabilityHeader from 'components/Location/FulfillmentMethodAvailabilityHeader';
import LocationListHeroContent from 'components/Location/LocationListHeroContent';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import { getHasHeroImage } from 'helpers/getHasHeroImage';

function CateringLocationScreenHero({ handleSortingLocations, locations }) {
  const { heroImage } = useAccount();

  const isGoogleApiLoaded = useGoogleApi();
  const theme = useTheme();
  const darkCoverBackground = theme.palette?.button?.background?.hover;
  const hasHeroImage = getHasHeroImage(heroImage);

  const getAvailableFulfillmentMethods = () => {
    return locations.reduce((acc, currentLocation) => {
      if (
        !currentLocation.is_closed_for_pickup &&
        !acc.includes(fulfillmentOptions.PICKUP)
      ) {
        acc.push(fulfillmentOptions.PICKUP);
      }
      if (
        !currentLocation.is_closed_for_delivery &&
        !acc.includes(fulfillmentOptions.DELIVERY)
      ) {
        acc.push(fulfillmentOptions.DELIVERY);
      }
      return acc;
    }, []);
  };

  const getHeroHeader = () => {
    const availableFulfillmentMethods = getAvailableFulfillmentMethods();
    return (
      <FulfillmentMethodAvailabilityHeader
        availableFulfillmentMethods={availableFulfillmentMethods}
        hasHeroImage={hasHeroImage}
      />
    );
  };
  return (
    <Hero image={heroImage}>
      <DarkCover
        dataTestId="dark-cover"
        background={hasHeroImage ? '' : darkCoverBackground}
      >
        {isGoogleApiLoaded && (
          <LocationListHeroContent
            heading={getHeroHeader()}
            handleSelect={handleSortingLocations}
            showAddressAutoComplete
            isLocationListSortingEnabled
            hasHeroImage={hasHeroImage}
          />
        )}
      </DarkCover>
    </Hero>
  );
}

CateringLocationScreenHero.propTypes = {
  locations: PropTypes.array.isRequired,
  handleSortingLocations: PropTypes.func.isRequired
};

export default CateringLocationScreenHero;
